// @flow
// we're using this perceived brightness algo for consistency with scramble4
// and because it's the one that alex specifically pointed out. polished also
// seems to implement a weighted perceived brightness algorithm in
// `getLuminance`.
import { getBrightness } from 'color-brightness';
import { parseToRgb, darken, lighten } from 'polished';
import type { RgbColor, RgbaColor } from 'polished/lib/types/color';

// TODO: Resolve this
// eslint-disable-next-line import/no-cycle
import { DEFAULT_DARKNESS_LINE } from './client-theme';

type Color = string | RgbColor | RgbaColor;

type IsDark = (color: Color, line?: number) => boolean;

export const withAlpha = (color: RgbColor | RgbaColor): RgbaColor => ({
  alpha: 1,
  ...color,
});

export const asRgba = (color: Color): RgbaColor => {
  if (typeof color === 'string') {
    return withAlpha(parseToRgb(color));
  }

  return withAlpha(color);
};

export const perceivedBrightness = (color: Color): number => {
  const { red, green, blue } = asRgba(color);
  return getBrightness(red, green, blue);
};

export const isDark: IsDark = (color, line = DEFAULT_DARKNESS_LINE) =>
  perceivedBrightness(color) < line;

export const darkenOrLighten =
  (amount: number, line?: number): ((color: string) => string) =>
  (color: string): string =>
    isDark(color, line) ? darken(amount, color) : lighten(amount, color);
